import { ssoInviteMemberResponseSchema, type SsoInviteMemberInput } from "@repo/shared";
import { authClient } from "../auth-client";
import { API_V1_PREFIX, apiRequestJson } from "../api-client";

type InvitationRole = "member" | "admin" | "owner";

export async function inviteMember(organizationId: string, email: string, role: InvitationRole) {
  return authClient.organization.inviteMember({ organizationId, email, role });
}

/** Login H2J (#700): the API invites through Login H2J, which e-mails the activation link. */
export async function inviteMemberViaH2j(input: SsoInviteMemberInput) {
  const response = await apiRequestJson({
    path: `${API_V1_PREFIX}/organization/invitations`,
    method: "POST",
    body: input,
    responseSchema: ssoInviteMemberResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
  return response.data;
}

export async function resendInvitation(
  organizationId: string,
  email: string,
  role: InvitationRole,
) {
  // Better-Auth resends the invitation email when `resend` is set.
  return authClient.organization.inviteMember({ organizationId, email, role, resend: true });
}

export async function cancelInvitation(invitationId: string) {
  return authClient.organization.cancelInvitation({ invitationId });
}

export async function getInvitation(invitationId: string) {
  return authClient.organization.getInvitation({ query: { id: invitationId } });
}

export async function acceptInvitation(invitationId: string) {
  return authClient.organization.acceptInvitation({ invitationId });
}

export async function rejectInvitation(invitationId: string) {
  return authClient.organization.rejectInvitation({ invitationId });
}

export async function listInvitations(organizationId: string) {
  return authClient.organization.listInvitations(
    { query: { organizationId } },
    { disableSignal: true },
  );
}
